{
  "login": {
    "title": "Sign In",
    "subtitle": "Welcome back",
    "emailLabel": "Email",
    "emailPlaceholder": "Enter your email",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter your password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "submitButton": "Sign In",
    "loggingIn": "Signing in...",
    "errors": {
      "emailRequired": "Email is required",
      "passwordRequired": "Password is required",
      "invalidCredentials": "Invalid email or password",
      "accountDisabled": "Your account has been disabled",
      "tooManyAttempts": "Too many login attempts. Please try again later."
    }
  },
  "forgotPassword": {
    "title": "Reset Password",
    "subtitle": "Enter your email to receive reset instructions",
    "emailLabel": "Email Address",
    "emailPlaceholder": "Enter your email",
    "submitButton": "Send Reset Link",
    "sending": "Sending...",
    "backToLogin": "Back to Sign In",
    "success": "Password reset instructions have been sent to your email",
    "errors": {
      "emailRequired": "Email is required",
      "invalidEmail": "Please enter a valid email address",
      "emailNotFound": "No account found with this email address",
      "rateLimited": "Too many requests. Please try again later."
    }
  },
  "resetPassword": {
    "title": "Create New Password",
    "subtitle": "Enter your new password",
    "passwordLabel": "New Password",
    "passwordPlaceholder": "Enter new password",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Re-enter new password",
    "submitButton": "Reset Password",
    "resetting": "Resetting...",
    "success": "Your password has been reset successfully",
    "backToLogin": "Back to Sign In",
    "errors": {
      "passwordRequired": "Password is required",
      "passwordTooShort": "Password must be at least 8 characters",
      "passwordComplexity": "Password must contain at least 3 of: lowercase, uppercase, digit, special character",
      "passwordMismatch": "Passwords do not match",
      "tokenInvalid": "Invalid or expired reset link",
      "tokenExpired": "This reset link has expired. Please request a new one."
    }
  },
  "expiredInvite": {
    "title": "Invitation Expired",
    "message": "This invitation has expired",
    "requestNew": "Request New Invitation",
    "requestingNew": "Requesting...",
    "emailLabel": "Email Address",
    "emailPlaceholder": "Enter your email",
    "success": "A new invitation has been sent to your email",
    "contactSupport": "If you continue to have issues, please contact support",
    "errors": {
      "emailRequired": "Email is required",
      "invalidEmail": "Please enter a valid email address",
      "noInviteFound": "No invitation found for this email",
      "alreadyUsed": "This invitation has already been used",
      "rateLimited": "Too many requests. Please try again later."
    }
  },
  "acceptInvite": {
    "title": "Create Your Account",
    "subtitle": "Complete your registration to get started",
    "emailLabel": "Email",
    "nameLabel": "Full Name",
    "countryLabel": "Country",
    "countryUSA": "United States",
    "countryNonUSA": "Non-USA",
    "minimumContribution": "Minimum Contribution",
    "invitationCode": "Invitation Code",
    "timeRemaining": "Time Remaining",
    "hours": "hours",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter your password",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "passwordRequirementsTitle": "Password must contain at least 3 of the following:",
    "requirement1": "At least 8 characters",
    "requirement2": "Contains uppercase letter (A-Z)",
    "requirement3": "Contains lowercase letter (a-z)",
    "requirement4": "Contains number (0-9)",
    "requirement5": "Contains special character (!@#$%...)",
    "complexityLabel": "Complexity: {{count}}/4 criteria met",
    "termsLabel": "I accept the",
    "termsLink": "Terms and Conditions",
    "submitButton": "Create Account",
    "creating": "Creating Account...",
    "success": "Account created successfully! Redirecting...",
    "errors": {
      "passwordRequired": "Please enter a password",
      "passwordTooShort": "Password must be at least 8 characters",
      "passwordComplexity": "Password must contain at least 3 of: uppercase, lowercase, number, symbol",
      "passwordMismatch": "Passwords do not match",
      "passwordConfirmRequired": "Please confirm your password",
      "termsRequired": "You must accept the terms and conditions",
      "inviteInvalid": "Invalid invitation code",
      "inviteExpired": "This invitation has expired",
      "inviteUsed": "This invitation has already been used",
      "accountExists": "An account with this email already exists"
    }
  }
}
